// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueAMap from 'vue-amap';
import router from './router'
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '1cf98e079933eb6e168684ca21a4ca41',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
import {
  Loading,
  Message
} from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper /* { default options with global component } */)
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import '@css/eleTheme/theme/index.css';  //引入的是Element的自定义主题包
// import '@css/element-variables.scss';    //单独改变Element的主题颜色scss文件
Vue.use(ElementUI);
import store from './vuex/store';
import moment from 'moment'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false


import md5 from 'js-md5'
Vue.prototype.$md5 = md5
// 图片放大预览控件样式
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer, { // 图片放大预览控件
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.prototype.$moment = moment; //时间格式化
// svg阿里字体全局注册
import SvgIcon from '@publicCom/svgIcon';
Vue.component("SvgIcon", SvgIcon);
// 手机端底部
import PagePhoneFooter from '@publicCom/pagePhoneFooter.vue';
Vue.component("PagePhoneFooter", PagePhoneFooter);

import '@css/reset.css';
import '@css/public.scss';
// import '@css/iconFont/iconfont.js';
// import '@css/iconFont/iconfont.css';
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js